import { render, staticRenderFns } from "./BillingGuidedTour.vue?vue&type=template&id=1145cb9c&"
import script from "./BillingGuidedTour.vue?vue&type=script&lang=ts&"
export * from "./BillingGuidedTour.vue?vue&type=script&lang=ts&"
import style0 from "./BillingGuidedTour.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports